var _defs, _ellipse, _g, _g2, _g3, _g4, _path, _g5, _path2, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign_in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1e938d;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #2bbbb2;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-6 {\n        clip-path: url(#sign_in__clippath);\n      }\n\n      .cls-4 {\n        fill: #d3d8da;\n      }\n\n      .cls-5 {\n        fill: #004d77;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "sign_in__clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 412.3,
    cy: 474.6,
    r: 286.5
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 400.8,
    cy: 952.6,
    rx: 388.7,
    ry: 77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M373.9,79c4.5,17.7-4.7,35.5-20.8,42.6l25.4,100.9c.8,3.2-1.2,6.6-4.4,7.4-3.3.8-6.6-1.2-7.4-4.4l-25.4-100.9c-17.6,1.5-34.1-10-38.6-27.6-5-19.7,7-39.6,26.6-44.6,19.7-5,39.6,6.9,44.6,26.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Back_Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M428.9,807.5c0,9.2-7.4,16.6-16.6,16.6s-16.6-7.4-16.6-16.6c0-7,4.3-13,10.5-15.4v-102.7c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1v102.7c6.1,2.4,10.5,8.4,10.5,15.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__R_Leg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Feet"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M647.2,925c0,12.9,10.5,23.4,23.4,23.4s23.4-10.5,23.4-23.4c0-8.7-4.7-16.3-11.8-20.3l17.8-189.2c.5-5.3-3.4-10-8.7-10.5s-10,3.4-10.5,8.7l-17.8,189.2c-9.2,3.1-15.8,11.8-15.8,22.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M588.8,654.1l69.5,49.5c-1.2,3.4-1.8,7.1-1.8,11,0,18.7,15.2,33.9,33.9,33.9s33.9-15.2,33.9-33.9-15.2-33.9-33.9-33.9c-7.9,0-15.1,2.7-20.8,7.2l-69.6-49.5c-4.3-3.1-10.4-2.1-13.5,2.3-3,4.3-2,10.3,2.3,13.4Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__L_Leg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Feet-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M182.3,925c0,12.9-10.5,23.4-23.4,23.4s-23.4-10.5-23.4-23.4c0-8.7,4.7-16.3,11.8-20.3l-17.8-189.2c-.5-5.3,3.4-10,8.7-10.5s10,3.4,10.5,8.7l17.8,189.2c9.2,3.1,15.8,11.8,15.8,22.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Leg-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.6,654.1l-69.5,49.5c1.2,3.4,1.8,7.1,1.8,11,0,18.7-15.2,33.9-33.9,33.9s-33.9-15.2-33.9-33.9,15.2-33.9,33.9-33.9c7.9,0,15.1,2.7,20.8,7.2l69.5-49.5c4.3-3.1,10.4-2.1,13.5,2.3,3.2,4.3,2.2,10.3-2.2,13.4Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M861.1,349.6h-6.9c-81.9,0-163.8,0-245.7.1-9.8,0-17.7-2.8-22.6-11.8-7.6-14.2,2-31.3,18.1-32.2,2.2-.1,4.4-.1,6.6-.1h250.1c-1.7-1.9-2.8-3.2-3.9-4.3-8.3-8.4-17-16.5-25-25.3-11.5-12.7-5.2-32.2,11.5-36.1,6.5-1.5,12.6-.1,17.9,3.9,1.6,1.2,3.1,2.7,4.6,4.1,20.8,20.8,41.6,41.6,62.4,62.4,11,11.1,11.1,23.6.1,34.5-21.1,21.2-42.2,42.3-63.4,63.4-12.1,12-29.5,9.6-36.6-4.6-4.3-8.5-2.7-18.2,4.6-25.7,7.8-8.1,15.8-15.9,23.8-23.8,1.4-1.3,2.4-2.4,4.4-4.5Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__finomate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Body"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 412.3,
    cy: 474.6,
    r: 286.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.8,301.3c-5.8,173.3,108.2,322.3,260.7,356,121.3,26.8,251.9-22.7,335.1-125.9,37.2,60.5,85.3,159.3,50.3,239.8-87.1,200.3-671.7,245.5-791.2,4.8-63.4-127.8,12.9-318.8,145.1-474.7Z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1069.2,337c-.9,6.6-1.6,13.1-2.7,19.7-9.2,53.7-37.1,95-82.9,124.1-35.9,22.8-75.5,31.3-117.5,25.8-53.5-6.9-95.7-33.2-126.8-77.4-7.3-10.4-5.1-23.6,4.7-30.8,10-7.4,23.4-5.5,31,5.1,14.4,20.3,32.3,36.2,54.8,47.1,57.4,27.9,129,10.4,167.3-40.6,21.2-28.3,30.9-60.2,27.2-95.2-5.3-49.5-30.2-87.2-75-109-53.3-25.9-104.1-18.8-150,18.8-9.3,7.6-16.5,17.8-24.3,27.1-7.2,8.7-17.4,11.8-27,7.5-12.7-5.7-17.1-20.7-9.2-32.7,8.6-13,18.9-24.6,30.6-34.8,27.4-23.9,59.2-38.5,95.2-43.3,33.8-4.4,66.5.2,97.7,14.3,36.3,16.4,64.3,42.2,83.9,76.8,12.9,22.7,20.3,47.2,22.2,73.3.1,1.7.5,3.4.8,5.1v19.1Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__L_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Leg-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.1,700l-72.3,80.9c4.4,6.1,7,13.6,7,21.8,0,20.6-16.7,37.3-37.3,37.3s-37.3-16.7-37.3-37.3,16.7-37.3,37.3-37.3c5.4,0,10.6,1.2,15.3,3.3l72.8-81.5c3.5-4,9.7-4.3,13.6-.8,4.1,3.6,4.5,9.7.9,13.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Feet-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307.8,979.5c0,14.4-11.7,26.1-26.1,26.1s-26.1-11.7-26.1-26.1c0-8.6,4.2-16.3,10.7-21l-37-156c-1.2-5.2,2-10.4,7.2-11.6,5.2-1.2,10.4,2,11.6,7.1l37,155.6c12.7,1.7,22.7,12.6,22.7,25.9Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__R_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Leg-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M615,583.3l102.4,35.9c-.9,7.5.5,15.3,4.4,22.4,10,18,32.6,24.6,50.6,14.6s24.5-32.6,14.6-50.6-32.6-24.6-50.6-14.6c-4.8,2.6-8.7,6.2-11.8,10.3l-103.2-36.3c-5-1.8-10.5.9-12.3,5.9-1.7,5.1.9,10.6,5.9,12.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Feet-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M890.1,504.4c7-12.6,2.4-28.5-10.2-35.5-12.6-7-28.5-2.4-35.4,10.2-4.2,7.6-4.2,16.3-.9,23.6l-107.9,118.6c-3.6,3.9-3.3,10,.6,13.6,3.9,3.6,10,3.3,13.6-.6l107.8-118.3c12,4.8,26,.1,32.4-11.6Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "sign_in__Eye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415.4,586.7c-96.7,0-175.4-78.7-175.4-175.4s78.7-175.4,175.4-175.4,175.4,78.7,175.4,175.4-78.7,175.4-175.4,175.4ZM415.4,278.2c-73.4,0-133.1,59.7-133.1,133.1s59.7,133.1,133.1,133.1,133.1-59.7,133.1-133.1-59.7-133.1-133.1-133.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 415.4,
    cy: 411.3,
    r: 116.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 474.5,
    cy: 377,
    r: 55.1,
    transform: "translate(26.36 784.98) rotate(-80.78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign_in.6acc5a5f0b181f9a66d09fae545000d4.svg";
export { ForwardRef as ReactComponent };